// extracted by mini-css-extract-plugin
module.exports = {"main":"main--3sNRF"};
    if(module.hot) {
      // 1732531514992
      var cssReload = require("/home/kartik/kvr-lsf/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"modules":{"namedExport":false},"locals":true});
      module.hot.dispose(cssReload);
      
    }
  